import React, { useState } from 'react';
import Button from '@blaze-react/button';
import { FaBars } from 'react-icons/fa';
import { Search } from './HeaderSearch';
import HeaderMenuContainer from './HeaderMenus';
import { MobileMenu } from './MobileMenu';
import Logo from '../Logo';
import { HEADER_MENUS } from '../../constants';

const Header = () => {
  const [isMobileMenuDisplayed, setIsMobileMenuDisplayed] = useState(false);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [currentSearchTerm, setCurrentSearchTerm] = useState('');

  const handleSearchTerm = value => {
    setCurrentSearchTerm(value);
  };

  const handleCloseSearchBar = () => {
    setIsSearchBarOpen(false);
    setCurrentSearchTerm('');
  };

  return (
    <header className="header">
      <div className="header__wrapper">
        <div className="header__row header__row--top">
          <div className="header__column">
            <Button
              type="button"
              className="icon-button icon-button--menu"
              id="menu-button"
              onClick={() => setIsMobileMenuDisplayed(true)}>
              <i>
                <FaBars />
              </i>
            </Button>

            <Logo type="header" />

            <HeaderMenuContainer headerMenus={HEADER_MENUS} />

            {currentSearchTerm && (
              <div
                role="button"
                className="search__modal-overlay search__modal-overlay--opaque"
                onClick={handleCloseSearchBar}
              />
            )}

            {!currentSearchTerm && isSearchBarOpen && (
              <div
                role="button"
                className="search__modal-overlay search__modal-overlay--white"
                onClick={handleCloseSearchBar}
              />
            )}
          </div>

          <Search
            handleSearchTerm={handleSearchTerm}
            setIsSearchBarOpen={setIsSearchBarOpen}
            isSearchBarOpen={isSearchBarOpen}
            currentSearchTerm={currentSearchTerm}
            closeSearchBar={handleCloseSearchBar}
          />

          {isMobileMenuDisplayed && (
            <MobileMenu onClose={setIsMobileMenuDisplayed} headerMenu={HEADER_MENUS} />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
